exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cartBlock[data-v-3c320bf4] {\n  transition: transform 0.5s;\n}\n.list-leave-active[data-v-3c320bf4] {\n  height: 0;\n  margin-bottom: 0;\n}\n.list-enter[data-v-3c320bf4], .list-leave-to[data-v-3c320bf4] /* .list-leave-active below version 2.1.8 */\n{\n  opacity: 0;\n  transform: translateY(-20px);\n}\n.order-enter-active[data-v-3c320bf4], .order-leave-active[data-v-3c320bf4] {\n  transition: opacity .3s ease;\n}\n.order-enter[data-v-3c320bf4], .order-leave-to[data-v-3c320bf4]\n  /* .component-fade-leave-active до версии 2.1.8 */\n{\n  opacity: 0;\n}\n", ""]);

// exports
